// eslint-disable-next-line @typescript-eslint/no-unused-vars
import axios, { AxiosError, AxiosRequestConfig } from "axios";
import { authResponse } from "../models/response/authResponse";

const $api = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_BASE_URL,
});

$api.defaults.withCredentials = true;

$api.interceptors.request.use((config: AxiosRequestConfig) => {
  config.headers!.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
});

$api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response.status === 401 &&
      error.config &&
      error.config._isRetry
    ) {
      originalRequest._isRetry = true;
      try {
        const response = await axios.get<authResponse>(`${process.env.REACT_APP_BASE_URL}/refresh`, {
          withCredentials: true,
        });
        localStorage.setItem("token", response.data.accessToken);
        return $api.request(originalRequest);
      } catch (err: AxiosError | unknown | any) {
        if (axios.isAxiosError(err)) {
          console.log(err.response);
        } else {
          console.log(err);
        }
      }
    }
    throw error;
  }
);

export default $api;
